module.exports = __webpack_public_path__ + "img/story-2.824120b8.jpg";